import React from 'react';

import Text, { TextType, TextProps } from 'components/typography/text';

const ActionSmall: React.FC<React.PropsWithChildren<TextProps>> = (props) => (
  <Text
    type={TextType.ACTION_SMALL}
    isExtended={props.isExtended}
    isResponsive={props.isResponsive || true}
    {...props}
  >
    {props.children}
  </Text>
);

export default ActionSmall;
